import { z } from 'zod';

export const AlertConfigurationSchema = z.object({
  time: z.number(),
  'high-latency': z.number(),
  recovery: z.number(),
  status: z.object({ main: z.number(), indeterminate: z.number() }),
});
